module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PatientHeader', {
    attrs: {
      "patient": _vm.patient,
      "carehomeid": _vm.carehomeid
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "home"
    }
  }, [_c('PatientOrderItems', {
    attrs: {
      "patient": _vm.patient,
      "start-date": "2017-10-29",
      "end-date": "2017-11-25"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "profile"
    }
  }, [_c('MedProfileForm', {
    attrs: {
      "patient": _vm.patient,
      "start-date": "2017-10-01",
      "end-date": "2017-10-28"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#home",
      "data-toggle": "tab"
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#profile",
      "data-toggle": "tab"
    }
  }, [_vm._v("Med Profile")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0d30c46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0d30c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/carehome-patients/detail/carehome-patient-main.scp.html
// module id = 516
// module chunks = 0